import { Component } from 'react';
import {connect} from "react-redux";
import { cancel } from '../../../redux/absences/absencesEditionActions'
import {withRouter} from 'react-router-dom'
import {compose} from 'redux'
import Icon from "@mui/material/Icon/Icon";
import Fab from "@mui/material/Fab";
import FooterFixedOnScreen from '../../../containers/Layout/FooterFixedOnScreen';

class ValidatedAbsence extends Component {

    cancel(){
        this.props.cancel(this.props.absences, this.props.activeUser);
    }

    render() {
        return (
            <FooterFixedOnScreen>
                <div className="offset-lg-9 col-lg-3 offset-md-8 col-md-4 offset-sm-6 col-sm-6 offset-6 col-6">
                    <Fab onClick={this.cancel.bind(this)}
                         className="red-button div-center">
                        <Icon>block</Icon>
                    </Fab>
                    <span className="floating-btn-text span-center">Annuler</span>
                </div>
            </FooterFixedOnScreen>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        absences: state.absences,
        activeUser: state.activeUser,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        cancel: (absencesState, activeUser) => dispatch(cancel(absencesState, activeUser)),
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ValidatedAbsence);
